import React, { Component } from 'react'
import intl from 'react-intl-universal'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import PropTypes from 'prop-types'
import AuthorisationHandler from '../components/AuthorisationHandler'
import shortid from 'shortid'

import Page from './Page'
import Input from '../components/Input'
import Loading from '../components/Loading'
import object_value from '../api/object_value'
import return_html from '../api/return_html'

@inject('user', 'rate_experience_store', 'my_bookings')
@observer
class RateExperiencePage extends Component {
  constructor (props, context) {
    super(props, context)
    this.state = {status: null}

    const {
      user,
      rate_experience_store,
      my_bookings
    } = props

    rate_experience_store.clean()

    const {token} = user
    my_bookings.get(token)

    this.stars = Array.from(new Array(5), (val,index) => index + 1 )
  }

  componentDidMount() {
    const {user, rate_experience_store} = this.props

    const experience_id = object_value(this, 'props.match.params.experience_id')
    rate_experience_store.set('experience_id', parseInt(experience_id))

    const event_id = object_value(this, 'props.match.params.event_id')
    rate_experience_store.set('event_id', parseInt(event_id))
  }

  is_booked_by_user = () => {
    const {
      rate_experience_store,
      my_bookings
    } = this.props

    return my_bookings.is_booked(rate_experience_store.experience_id, rate_experience_store.event_id)
  }

  stepIsDisabled = (step) => {
    // const {state} = this
    const {rate_experience_store} = this.props

    step = parseInt(step)
    let step_1 = !rate_experience_store.general
    let step_2 = step_1
      || !rate_experience_store.price
      || !rate_experience_store.organiser
    let step_3 = step_2
      || !rate_experience_store.text

    if (step === 1) {
      return step_1
    }

    if (step === 2) {
      return step_2
    }

    if (step === 3) {
      return step_3
    }

    return true
  }

  handleStepChange = (step) => {
    const {rate_experience_store} = this.props
    rate_experience_store.set('current_step', parseInt(step))
  }

  handleSubmit = async (event) => {
    event.preventDefault()
    console.log('RateExperiencePage.js - handleSubmit()', event)
    const {user, rate_experience_store} = this.props
    const {current_step, steps} = rate_experience_store

    // Next step
    console.log('RateExperiencePage.js - handleSubmit() - step', current_step, steps.length)
    if (current_step < steps.length) {
      rate_experience_store.set('current_step', current_step + 1)
      return
    }

    const {token} = user
    rate_experience_store.request(token)
  }

  handleInputChange = async (event) => {
    console.log('RateExperiencePage.js - handleInputChange() - event.target', event.target)
    console.log('RateExperiencePage.js - handleInputChange() - event.value', event.value)
    const target = event.target

    let value = event.value
    if (target) {
      if (target.type === 'checkbox') {
        value = target.checkbox
      } else if (target.type === 'number' || target.type === 'radio') {
        value = parseInt(target.value)
      } else {
        value = target.value
      }
    }

    const name = target
      ? target.name
      : event.name

    console.log('handleInputChange()', name, value)

    const {rate_experience_store} = this.props
    rate_experience_store.set(name, value)
  }

  handleRestart = () => {
    const {rate_experience_store} = this.props
    rate_experience_store.restart_form()
  }

  render () {
    const {
      rate_experience_store,
      my_bookings
    } = this.props

    const {
      status,
      status_message,
      steps,
      current_step,
      general,
      price,
      organiser,
      text
    } = rate_experience_store

    console.log('RateExperiencePage.js - render() - rate_experience_store', rate_experience_store)

    function stepClass (step, baseStyle = '') {
      let isCurrent = current_step === step
      return isCurrent ? baseStyle + ' current' : baseStyle
    }

    if (!my_bookings.loaded) {
      <Page title='Rate event'>
        <div><Loading /></div>
      </Page>
    }

    if (!this.is_booked_by_user()) {
      return (
        <Page title='Rate event - Not booked'>
          <article className='b-info'>
            <h2 className='b-info-title'>{intl.get('rate_experience.not_booked')}</h2>
          </article>
        </Page>
      )
    }

    if (status === 'error') {
      return (
        <Page title='Rate event - Error'>
          <article className='b-info'>
            <h2 className='b-info-title'>Something went wrong :(</h2>
            <p><button className='b-button'
                       onClick={this.handleRestart}>Retry</button></p>
            <h3 className='b-info-subtitle'>Error</h3>
            <code dangerouslySetInnerHTML={return_html(status_message.toString())} />
          </article>
        </Page>
      )
    }

    if (status === 'success') {
      return (
        <Page title='Rate event - Success'>
          <article className='b-info'>
            <h2 className='b-info-title'>{intl.get('rate_experience.rated')}</h2>
          </article>
        </Page>
      )
    }

    return (
      <AuthorisationHandler>
        <Page title='Rate event'>
          {status === 'loading' || this.is_booked_by_user() === 'loading' ? <div><Loading /></div> :
          <section className='b-create-event'>
            {status === 'not_booked' && <div>not your</div>}

            <div className='b-create-event-indicator'>
              {steps.map((name, index) =>
                <div className={stepClass(index + 1, 'b-create-event-indicator-step')}
                     key={shortid.generate()}>
                  <button className={stepClass(index + 1, 'b-create-event-indicator-step-button')}
                          disabled={index > 0 && this.stepIsDisabled(index)}
                          type='button'
                          onClick={() => this.handleStepChange(index + 1)}>
                    <span
                      className='b-create-event-indicator-step-button-label'>{name}</span>
                    <span
                      className='b-create-event-indicator-step-button-index'>{index + 1}</span>
                  </button>
                </div>
              )}
            </div>

            {/* step 1 */}
            <form className={stepClass(1, 'b-create-event-form-step')}
                  onSubmit={this.handleSubmit}>
              <h2 className='b-create-event-title'>{intl.get('rate_experience.how')}</h2>

              <div className='b-form-row'>
                <div className='b-select-stars'>
                  {this.stars.map(star_index =>
                    <label key={shortid.generate()}
                           className='b-select-stars-star'>
                      <input type='radio'
                             id='general'
                             name='general'
                             value={star_index}
                             defaultChecked={parseInt(general) === star_index ? 'checked' : ''}
                             onChange={this.handleInputChange} />
                      <span className={parseInt(general) >= star_index ? 'filled' : ''}></span>
                    </label>)}
                </div>
              </div>

              <div className='b-form-row'
                   style={{marginTop: '7.2rem'}}>
                <div className='b-form-item'>
                  <button className='b-button b-button_primary b-button_x'
                        type='submit'
                        disabled={this.stepIsDisabled(1)}>
                    {intl.get('rate_experience.save_and_next')}
                  </button>
                </div>
              </div>
            </form>

            {/* step 2 */}
            <form className={stepClass(2, 'b-create-event-form-step')}
                  onSubmit={this.handleSubmit}>
              <h2 className='b-create-event-subtitle'>{intl.get('rate_experience.price')}</h2>

              <div className='b-form-row'>
                <div className='b-select-stars'>
                  {this.stars.map(star_index =>
                    <label key={shortid.generate()}
                           className='b-select-stars-star'>
                      <input type='radio'
                             id='price'
                             name='price'
                             value={star_index}
                             defaultChecked={parseInt(price) === star_index ? 'checked' : ''}
                             onChange={this.handleInputChange} />
                      <span className={parseInt(price) >= star_index ? 'filled' : ''}></span>
                    </label>)}
                </div>
              </div>

              <h2 className='b-create-event-subtitle'>{intl.get('rate_experience.organizer')}</h2>

              <div className='b-form-row'>
                <div className='b-select-stars'>
                  {this.stars.map(star_index =>
                    <label key={shortid.generate()}
                           className='b-select-stars-star'>
                      <input type='radio'
                             id='organiser'
                             name='organiser'
                             value={star_index}
                             defaultChecked={parseInt(organiser) === star_index ? 'checked' : ''}
                             onChange={this.handleInputChange} />
                      <span className={parseInt(organiser) >= star_index ? 'filled' : ''}></span>
                    </label>)}
                </div>
              </div>

              <div className='b-form-row'
                   style={{marginTop: '7.2rem'}}>
                <div className='b-form-item'>
                  <button className='b-button b-button_primary b-button_x'
                          type='submit'
                          disabled={this.stepIsDisabled(2)}>
                    {intl.get('rate_experience.save_and_next')}
                  </button>
                </div>
              </div>
            </form>

            {/* step 3 */}
            <form className={stepClass(3, 'b-create-event-form-step')}
                  onSubmit={this.handleSubmit}>
              <h2 className='b-create-event-subtitle'>{intl.get('rate_experience.write_review')}</h2>

              <div className='b-form-row'>
                <div className='b-form-item b-form-item_x'>
                  <Input element_type='textarea'
                         className='b-form-item-input-text'
                         id='text'
                         name='text'
                         defaultValue={text || ''}
                         onChange={this.handleInputChange}
                         required
                  />
                  <label className='b-form-item-label' htmlFor='text'>
                    {intl.get('rate_experience.write_message')}
                  </label>
                </div>
              </div>

              <div className='b-form-row'>
                <div className='b-form-item'>
                  <button className='b-button b-button_primary b-button_x'
                          type='submit'
                          disabled={this.stepIsDisabled(3)}>
                    {intl.get('Submit')}
                  </button>
                </div>
              </div>
            </form>

          </section>}
        </Page>
      </AuthorisationHandler>
    )
  }
}

RateExperiencePage.propTypes = {
  rate_experience_store: MobxPropTypes.observableObject,
  my_bookings: MobxPropTypes.observableObject,
  history: PropTypes.any,
  location: MobxPropTypes.objectOrObservableObject
}

export default RateExperiencePage



// WEBPACK FOOTER //
// ./src/containers/RateExperiencePage.js